import ClientApi from './api/client.api'
import AccountApi from './api/account.api'
import AdminApi from './api/admin.api'

export default {
    Client: ClientApi,
    Account: AccountApi,
    Admin: AdminApi
}